import { useSession } from "@clerk/clerk-react";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import { Save } from "assets/icons";
import ButtonNew from "components/buttonNew/buttonNew";
import { EditableTextareaComponent } from "components/index";
import { API_URL } from "constants/index";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { RentalContract } from "shared/types/rental-contracts";

export interface EditWatchListModalProps {
    isOpen: boolean;
    onClose?: () => void;
    incomingContract: RentalContract | null;
    handleContractRefresh: () => void;
}

export const EditWatchListModal = ({ isOpen, onClose, incomingContract, handleContractRefresh }: EditWatchListModalProps) => {
    const [selectedContract, setSelectedContract] = useState<RentalContract | null>(null);
    const [watchListReason, setWatchListReason] = useState<string | null>(null);
    const { session } = useSession();

    useEffect(() => {
        setSelectedContract(incomingContract);
        setWatchListReason(incomingContract?.flaggedForWatchlistReason || null);
    }, [incomingContract]);

    const handleClose = () => {
        setSelectedContract(null);
        setWatchListReason(null);
        onClose && onClose();
    };
    
    const updateWatchListReason = async () => {
        if(!selectedContract) return toast.error("Geen contract geselecteerd");
        try {
            await fetchWithAuth(
                `${API_URL}/rental/watchlist/${selectedContract?.id}/reason`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ watchListReason }),
                },
                session,
            );
            toast.success("Watchlist reden aangepast");
            handleContractRefresh && handleContractRefresh();
        } catch (error) {
            console.error("Failed to update watchlist reason:", error);
        } finally {
            setSelectedContract(null);
            setWatchListReason(null);
            handleClose();
        }
    };

    return (
        <Modal onClose={handleClose} isOpen={isOpen} isDismissable={true} isKeyboardDismissDisabled={true} className="font-normal text-neutral-primary" size="4xl" scrollBehavior="inside">
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <p className="flex items-center gap-1 text-sm font-medium text-status-bad">
                                Bewerk reden waarom dit contract op de watchlist staat
                            </p>
                        </ModalHeader>
                        <ModalBody>
                            <EditableTextareaComponent
                                value={watchListReason || ""}
                                onChange={(value) => setWatchListReason(value)}
                                label="Geef de reden om dit contract op de watchlist te plaatsen"
                                editMode={true}
                                isLoading={false}
                            />
                        </ModalBody>
                        <ModalFooter className="justify-start">
                            <ButtonNew
                                variant="primaryStatusGreen"
                                onClick={updateWatchListReason}
                                icon={<Save />}
                                label={`Opslaan`}
                            />
                            <ButtonNew
                                variant="secondaryNeutral"
                                onClick={onClose}
                                label="Cancel"
                            />
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};
